$(function () {
  var datetimeFormat = "YYYY-MM-DDTHH:mm:ssZ";
  var elementName = "input.js-datetimepicker";
  $(elementName).daterangepicker({
    // 参考： http://www.daterangepicker.com/
    locale: {
      format: datetimeFormat,
      applyLabel: "決定",
      cancelLabel: "クリア",
      daysOfWeek: ["日", "月", "火", "水", "木", "金", "土"],
      monthNames: ["1月", "2月", "3月", "4月", "5月", "6月", "7月", "8月", "9月", "10月", "11月", "12月"]
    },
    singleDatePicker: true,
    timePicker: true,
    timePicker24Hour: true,
    timePickerIncrement: 5,
    autoUpdateInput: false
  });

  $(elementName).on("apply.daterangepicker", function (ev, picker) {
    $(this).val(picker.startDate.format(datetimeFormat)).trigger("change");
  });

  $(elementName).on("cancel.daterangepicker", function (ev, picker) {
    $(this).val("").trigger("change");
  });
});

$(function () {
  var datetimeFormat = "YYYY-MM-DDTHH:mm:ssZ";
  var elementName = "input.js-datetimepicker-hour";
  $(elementName).daterangepicker({
    // 参考： http://www.daterangepicker.com/
    locale: {
      format: datetimeFormat,
      applyLabel: "決定",
      cancelLabel: "クリア",
      daysOfWeek: ["日", "月", "火", "水", "木", "金", "土"],
      monthNames: ["1月", "2月", "3月", "4月", "5月", "6月", "7月", "8月", "9月", "10月", "11月", "12月"]
    },
    singleDatePicker: true,
    timePicker: true,
    timePicker24Hour: true,
    timePickerMinutes: false,
    timePickerSeconds: false,
    autoUpdateInput: false,
  });

  $(elementName).on("apply.daterangepicker", function (ev, picker) {
    $(this).val(picker.startDate.format(datetimeFormat)).trigger("change");
  });

  $(elementName).on("cancel.daterangepicker", function (ev, picker) {
    $(this).val("").trigger("change");
  });
});

$(function () {
  var datetimeFormat = "YYYY-MM-DD";
  var elementName = "input.js-datepicker";
  $(elementName).daterangepicker({
    // 参考： http://www.daterangepicker.com/
    locale: {
      format: datetimeFormat,
      applyLabel: "決定",
      cancelLabel: "クリア",
      daysOfWeek: ["日", "月", "火", "水", "木", "金", "土"],
      monthNames: ["1月", "2月", "3月", "4月", "5月", "6月", "7月", "8月", "9月", "10月", "11月", "12月"]
    },
    singleDatePicker: true,
    timePicker: false,
    autoUpdateInput: false
  });

  $(elementName).on("apply.daterangepicker", function (ev, picker) {
    $(this).val(picker.startDate.format(datetimeFormat)).trigger("change");
  });

  $(elementName).on("cancel.daterangepicker", function (ev, picker) {
    $(this).val("").trigger("change");
  });
});


$(function () {
  var datetimeFormat = "YYYY-MM-DD";
  var elementName = "input.js-daterangepicker";
  $(elementName).daterangepicker({
    // 参考： http://www.daterangepicker.com/
    locale: {
      format: datetimeFormat,
      applyLabel: "決定",
      cancelLabel: "クリア",
      daysOfWeek: ["日", "月", "火", "水", "木", "金", "土"],
      monthNames: ["1月", "2月", "3月", "4月", "5月", "6月", "7月", "8月", "9月", "10月", "11月", "12月"]
    },
    timePicker: false
  });
});